"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostMessage = exports.wParent = void 0;
exports.wParent = window.parent;
const usePostMessage = (message, targetOrigin = "*") => {
    const wParent = window.parent;
    console.log("[usePostMessage]", message);
    if (wParent && wParent.postMessage) {
        return wParent.postMessage(message, targetOrigin);
    }
};
exports.usePostMessage = usePostMessage;
